import React, { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const defaultLocation = { lat: 3.1554884, lng: 113.094029 };

const MapPicker = ({ location, setLocation }) => {
  const mapRef = useRef(null);
  const markerRef = useRef(null);

  useEffect(() => {
    if (!mapRef.current) {
      mapRef.current = L.map("map-picker").setView([location.lat, location.lng], 13);

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: '&copy; OpenStreetMap contributors',
      }).addTo(mapRef.current);

      markerRef.current = L.marker([location.lat, location.lng], {
        draggable: true,
      }).addTo(mapRef.current);

      markerRef.current.on("dragend", () => {
        const { lat, lng } = markerRef.current.getLatLng();
        setLocation({ lat, lng });
      });

      mapRef.current.on("click", (e) => {
        const { lat, lng } = e.latlng;
        markerRef.current.setLatLng([lat, lng]);
        setLocation({ lat, lng });
      });

      // ✅ Add visible Reset Button
      const resetControl = L.control({ position: "topright" });
      resetControl.onAdd = () => {
        const div = L.DomUtil.create("div", "leaflet-control leaflet-bar");

        div.innerHTML = `<button type="button" title="Reset Map" style="
  background-color: white;
  border: 1px solid #ccc;
  padding: 6px 10px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
">Reset</button>`;


        // Prevent map from catching button click
        L.DomEvent.disableClickPropagation(div);
        div.onclick = () => {
          mapRef.current.setView([defaultLocation.lat, defaultLocation.lng], 13);
          markerRef.current.setLatLng([defaultLocation.lat, defaultLocation.lng]);
          setLocation(defaultLocation);
        };
        return div;
      };
      resetControl.addTo(mapRef.current);
    } else {
      mapRef.current.setView([location.lat, location.lng]);
      markerRef.current.setLatLng([location.lat, location.lng]);
    }
  }, [location.lat, location.lng]);

  return (
    <div
      id="map-picker"
      style={{
        height: "300px",
        width: "100%",
        marginTop: "10px",
        borderRadius: "8px",
        overflow: "hidden",
      }}
    />
  );
};

export default MapPicker;
